import { Link } from 'react-router-dom'
import Logo from './Logo'

export default function Footer() {
  return (
    <footer id="app-footer" className="mt-auto border-t border-line bg-surface">
      <div className="mx-auto flex max-w-[1200px] flex-col items-center gap-3 px-4 py-5 sm:px-6 md:flex-row md:justify-between lg:px-8">
        <p className="flex items-center gap-2 text-sm text-ink-muted">
          <Logo size={16} />
          <span>© {new Date().getFullYear()} Finance Prévision</span>
        </p>
        <nav className="flex items-center gap-1" aria-label="Liens secondaires">
          <Link
            to="/aide"
            className="rounded-sm px-2 py-1 text-sm text-ink-secondary transition-colors duration-fast hover:text-ink"
          >
            Aide
          </Link>
          <span aria-hidden="true" className="text-ink-disabled">
            ·
          </span>
          <Link
            to="/apropos"
            className="rounded-sm px-2 py-1 text-sm text-ink-secondary transition-colors duration-fast hover:text-ink"
          >
            À propos
          </Link>
        </nav>
      </div>
    </footer>
  )
}
